export const SEO_VALIDATION = {
    title: {
        required: 'Meta title wajib diisi',
    },
    description: {
        required: 'Meta description wajib diisi',
    },
}
